import { render, staticRenderFns } from "./iti-language-selector.component.html?vue&type=template&id=3ad648a2&scoped=true&"
import script from "./iti-language-selector.component.ts?vue&type=script&lang=ts&"
export * from "./iti-language-selector.component.ts?vue&type=script&lang=ts&"
import style0 from "./iti-language-selector.component.scss?vue&type=style&index=0&id=3ad648a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad648a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VBtn,VList,VListItem,VListItemTitle,VMenu})
